import React, { FC } from 'react';
import { Route, Switch } from 'react-router-dom';
import SettingsFeaturesPage from './components/SettingsFeaturesPage/SettingsFeaturesPage';
import SettingsNotificationsPage from './components/SettingsNotificationsPage/SettingsNotificationsPage';

const AppSettingsFeature: FC = () => (
  <Switch>
    <Route path="/maps/settings/feature-selector" exact>
      <SettingsFeaturesPage />
    </Route>
    <Route path="/maps/settings/notifications" exact>
      <SettingsNotificationsPage />
    </Route>
  </Switch>
);

export default AppSettingsFeature;
